import axios from "axios";
import {CLIENT_ENDPOINT} from "../../config";

export default axios.create({
  baseURL: `${CLIENT_ENDPOINT}/clients`,
  headers: {"Content-Type": "application/json"},
});
